import { Navigate } from 'react-router-dom';

// Retain the old URL so already-issued email links land on the new sign-in flow.
export const AuthVerifyPage = () => <Navigate to="/sign-in" replace />;
